import React, { useState, useEffect } from 'react';
import axios from 'axios';
import TableScrollContainer from '../components/TableScrollContainer';
import './Usuarios.css';

const EMPTY_FORM = { usuario: '', email: '', senha: '', nome: '' };

function Usuarios() {
  const [lista, setLista] = useState([]);
  const [form, setForm] = useState(EMPTY_FORM);
  const [editando, setEditando] = useState(null); // id do usuario sendo editado
  const [editForm, setEditForm] = useState({});
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState('');

  useEffect(() => { carregar(); }, []);

  const carregar = async () => {
    try {
      const res = await axios.get('/api/usuarios');
      setLista(res.data);
    } catch (e) {
      setErro('Erro ao carregar usuários.');
    }
  };

  const showSucesso = (msg) => {
    setSucesso(msg);
    setTimeout(() => setSucesso(''), 3000);
  };

  const handleAddSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setLoading(true);
    try {
      await axios.post('/api/usuarios', form);
      setForm(EMPTY_FORM);
      await carregar();
      showSucesso('Usuário criado com sucesso!');
    } catch (e) {
      setErro(e.response?.data?.error || 'Erro ao criar usuário.');
    } finally {
      setLoading(false);
    }
  };

  const iniciarEdicao = (u) => {
    setEditando(u.id);
    setEditForm({ usuario: u.usuario, email: u.email || '', nome: u.nome || '', senha: '', ativo: u.ativo });
    setErro('');
  };

  const cancelarEdicao = () => {
    setEditando(null);
    setEditForm({});
    setErro('');
  };

  const salvarEdicao = async (id) => {
    setErro('');
    if (!editForm.usuario) { setErro('Login é obrigatório.'); return; }
    try {
      await axios.put(`/api/usuarios/${id}`, editForm);
      setEditando(null);
      await carregar();
      showSucesso('Usuário atualizado!');
    } catch (e) {
      setErro(e.response?.data?.error || 'Erro ao salvar.');
    }
  };

  const excluir = async (u) => {
    if (!window.confirm(`Excluir o usuário "${u.nome || u.usuario}"?`)) return;
    setErro('');
    try {
      await axios.delete(`/api/usuarios/${u.id}`);
      await carregar();
      showSucesso('Usuário excluído.');
    } catch (e) {
      setErro(e.response?.data?.error || 'Erro ao excluir.');
    }
  };

  const toggleAtivo = async (u) => {
    if (u.usuario === 'admin') { setErro('Não é possível desativar o administrador principal.'); return; }
    try {
      await axios.put(`/api/usuarios/${u.id}`, { ativo: u.ativo ? 0 : 1 });
      await carregar();
    } catch (e) {
      setErro(e.response?.data?.error || 'Erro ao alterar status.');
    }
  };

  return (
    <div className="usuarios-page">
      <div className="usuarios-header">
        <h2>🔑 Gerenciar Usuários</h2>
        <span className="usuarios-badge">Restrito ao administrador</span>
      </div>

      {erro && <div className="usuarios-erro">{erro}</div>}
      {sucesso && <div className="usuarios-sucesso">{sucesso}</div>}

      {/* ── Formulário de criação ── */}
      <div className="usuarios-card">
        <h3>Novo Usuário</h3>
        <form className="usuarios-form" onSubmit={handleAddSubmit}>
          <div className="usuarios-form-row">
            <div className="usuarios-field">
              <label>Nome</label>
              <input
                type="text"
                placeholder="Nome de exibição"
                value={form.nome}
                onChange={(e) => setForm({ ...form, nome: e.target.value })}
              />
            </div>
            <div className="usuarios-field">
              <label>Login *</label>
              <input
                type="text"
                placeholder="login (sem espaços)"
                value={form.usuario}
                onChange={(e) => setForm({ ...form, usuario: e.target.value.replace(/\s/g, '') })}
                required
              />
            </div>
            <div className="usuarios-field">
              <label>E-mail</label>
              <input
                type="email"
                placeholder="email@exemplo.com"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value.trim() })}
              />
            </div>
            <div className="usuarios-field">
              <label>Senha *</label>
              <input
                type="password"
                placeholder="senha"
                value={form.senha}
                onChange={(e) => setForm({ ...form, senha: e.target.value })}
                required
              />
            </div>
            <button className="btn-criar" type="submit" disabled={loading}>
              {loading ? '...' : '+ Criar'}
            </button>
          </div>
        </form>
      </div>

      {/* ── Lista de usuários ── */}
      <div className="usuarios-card">
        <h3>Usuários cadastrados</h3>
        <TableScrollContainer rows={lista.length}>
          <table className="usuarios-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Nome</th>
              <th>Login</th>
              <th>E-mail</th>
              <th>Status</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {lista.map((u) =>
              editando === u.id ? (
                <tr key={u.id} className="editando">
                  <td>{u.id}</td>
                  <td>
                    <input
                      value={editForm.nome}
                      onChange={(e) => setEditForm({ ...editForm, nome: e.target.value })}
                      placeholder="Nome"
                    />
                  </td>
                  <td>
                    <input
                      value={editForm.usuario}
                      onChange={(e) => setEditForm({ ...editForm, usuario: e.target.value.replace(/\s/g, '') })}
                      placeholder="Login"
                      disabled={u.id === 1}
                    />
                  </td>
                  <td>
                    <input
                      type="email"
                      value={editForm.email}
                      onChange={(e) => setEditForm({ ...editForm, email: e.target.value.trim() })}
                      placeholder="E-mail"
                    />
                  </td>
                  <td>
                    <input
                      type="password"
                      value={editForm.senha}
                      onChange={(e) => setEditForm({ ...editForm, senha: e.target.value })}
                      placeholder="Nova senha (opcional)"
                    />
                  </td>
                  <td>
                    <div className="acoes">
                      <button className="btn-salvar" onClick={() => salvarEdicao(u.id)}>✓ Salvar</button>
                      <button className="btn-cancelar" onClick={cancelarEdicao}>✕</button>
                    </div>
                  </td>
                </tr>
              ) : (
                <tr key={u.id} className={u.ativo ? '' : 'inativo'}>
                  <td>{u.id}</td>
                  <td>{u.nome || '—'}</td>
                  <td><code>{u.usuario}</code></td>
                  <td>{u.email ? <span className="usuarios-email">{u.email}</span> : <span style={{ color: '#94a3b8' }}>—</span>}</td>
                  <td>
                    <span
                      className={`ativo-badge ${u.ativo ? 'ativo' : 'desativo'}`}
                      onClick={() => toggleAtivo(u)}
                      title="Clique para alternar"
                    >
                      {u.ativo ? 'Ativo' : 'Inativo'}
                    </span>
                  </td>
                  <td>
                    <div className="acoes">
                      <button className="btn-editar" onClick={() => iniciarEdicao(u)}>✏️ Editar</button>
                      {u.usuario !== 'admin' && (
                        <button className="btn-excluir" onClick={() => excluir(u)}>🗑️</button>
                      )}
                    </div>
                  </td>
                </tr>
              )
            )}
          </tbody>
          </table>
        </TableScrollContainer>
      </div>
    </div>
  );
}

export default Usuarios;
